import { render, staticRenderFns } from "./TemplatesDoc.vue?vue&type=template&id=3370b4f6&"
import script from "./TemplatesDoc.vue?vue&type=script&lang=js&"
export * from "./TemplatesDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3370b4f6')) {
      api.createRecord('3370b4f6', component.options)
    } else {
      api.reload('3370b4f6', component.options)
    }
    module.hot.accept("./TemplatesDoc.vue?vue&type=template&id=3370b4f6&", function () {
      api.rerender('3370b4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/formioTemplates/vistas/TemplatesDoc.vue"
export default component.exports